import { createContext, useContext } from 'react';

export type GlobalPrintModeContext = {
  isInGlobalPrintMode: boolean;
};

/**
 * Context for deciding if a component is in the global print mode.
 */
export const GlobalPrintModeProvider = createContext<GlobalPrintModeContext>({ isInGlobalPrintMode: false });
export const useGlobalPrintMode = () => useContext(GlobalPrintModeProvider);
